/**
 * Checks window.location.href in order to see if -dev is in the url.
 *
 * For example: ceh-dev.teams.microsoft.com, indicated we are in a dev environment.
 */
export const isDev = () => {
  return windowContainsPrefix('-dev');
};

/**
 * Checks window.location.href in order to see if -canary is in the url.
 *
 * For example: cehclient-canary.teams.microsoft.com, indicated we are in a dev environment.
 */
export const isCanary = () => {
  return windowContainsPrefix('-canary');
};

/**
 * Checks window.location.href in order to see if -ppe is in the url.
 *
 * For example: cehclient-ppe.teams.microsoft.com, indicated we are in a dev environment.
 */
export const isPPE = () => {
  return windowContainsPrefix('-ppe');
};

/**
 * Checks window.location.href in order to see if no other environment prefix's are in the url.
 *
 * For example: cehclient.teams.microsoft.com, indicated we are in a dev environment.
 */
export const isProd = () => {
  return !isDev() && !isCanary() && !isPPE();
};

export enum EnvironmentNames {
  canary = 'canary',
  dev = 'dev',
  ppe = 'ppe',
  prod = 'prod'
}

/**
 * Returns the name of the environment, based on the isEnv checks.
 */
export const getEnvironmentName = () => {
  if (isDev()) {
    return EnvironmentNames.dev;
  } else if (isCanary()) {
    return EnvironmentNames.canary;
  } else if (isPPE()) {
    return EnvironmentNames.ppe;
  } else if (isProd()) {
    return EnvironmentNames.prod;
  } else {
    return EnvironmentNames.prod;
  }
};

const windowContainsPrefix = (prefix: string) => {
  const location = window.location;
  if (location.href.indexOf(prefix) > -1) {
    return true;
  }
  return false;
};
